<template>
  <div class="loader-custom">
    <span class="spinner-border" role="status" aria-hidden="true"></span>
  </div>
</template>
<script>
import { Vue } from 'vue-facing-decorator';

export default class LoaderCover extends Vue {}
</script>
<style lang="scss" scoped>
.loader-custom {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: grid;
  place-items: center;

  .spinner-border {
    width: 50px;
    height: 50px;
  }
}
</style>
